module.exports = __webpack_public_path__ + "img/1418892125.64248033.jpg";